<template>
    <div>
        <google-analytics v-if="gaActive"></google-analytics>
        <ivw v-if="ivwActive"></ivw>
        <agf v-if="agfActive"></agf>
        <ga4 v-if="ga4Active"></ga4>
    </div>
</template>

<script>
import GoogleAnalytics from './GoogleAnalytics.vue'
import agf from './agf.js'
import ivw from './ivw.js'
import ga4 from './ga4.js'

export default {

    data() {
        return {
            gaActive: true, //GA component is handling this itself
            ivwActive: false,
            agfActive: false,
            ga4Active: true,
        }
    },

    components: {
        GoogleAnalytics,
        'ivw': ivw,
        'agf': agf,
        'ga4': ga4,
    },

    mounted() {
        this.$nextTick(function () {
            var vm = this;

            // GA component handles this itself:
            // if(this.$manager.get('googleAnalytics.active')) {
            //     this.gaActive = true
            // }

            if (this.$manager.get('ivw.active')) {
                this.$manager.vendorGrant('5efefe25b8e05c065164a2e2').then(function (grants) {
                    if (grants) {
                        vm.$l.log('IVW granted by consent tool (vendorGrant)')
                        vm.ivwActive = true
                    } else {
                        vm.$l.log('IVW NOT granted by consent tool (vendorGrant)')
                    }

                })
            }

            if (this.$manager.get('agf.active')) {
                this.agfActive = true
            }

            if (this.$manager.get('ga4.active')) {
                this.ga4Active = true
            }

        })
    }

}
</script>



// WEBPACK FOOTER //
// src/components/tracking/Tracking.vue